<template>
  <div>
    <b-form-group
        :label="$t('message.Name_uz')"
        label-for="name-input"
        invalid-feedback="Name is required"
    >
      <b-form-input
          id="name-input"
          v-model="lidership_experience.name_uz"
          required
      />
    </b-form-group>
    <b-form-group
        :label="$t('message.Name_ru')"
        label-for="name-input"
        invalid-feedback="Name is required"
    >
      <b-form-input
          id="name-input"
          v-model="lidership_experience.name_ru"
          required
      />
    </b-form-group>
    <b-form-group
        :label="$t('message.Name_en')"
        label-for="name-input"
        invalid-feedback="Name is required"
    >
      <b-form-input
          id="name-input"
          v-model="lidership_experience.name_en"
          required
      />
    </b-form-group>
    <b-form-group
        :label="$t('message.Name_kr')"
        label-for="name-input"
        invalid-feedback="Name is required"
    >
      <b-form-input
          id="name-input"
          v-model="lidership_experience.name_kz"
          required
      />
    </b-form-group>
    <div
        style="margin-top: 30px; margin-left: 150px">
      <b-button
          variant="outline-primary"
          @click="handleClick"
      >{{$t('message.Cancel')}}
      </b-button>
      <b-button
          @click="handleSubmit"
          style="margin-left: 10px"
          variant="primary"
      >{{$t('message.Add')}}
      </b-button>
    </div>
  </div>
</template>

<script>

import {
  addLidershipExperience,
  editLidershipExperience,
  getLidershipExperienceById
} from "../../../../../../api/lidership_experience";

export default {
  name: "LidershipModal",
  props: {
    activeModal: {
      type: Boolean
    },
    id: {
      default: null,
    }
  },
  data(){
    return{
      lidership_experience: {
        name_uz: '',
        name_ru: '',
        name_en: '',
        name_kz: ''
      },
    }
  },
  computed: {
    modalActive: {
      get() {
        return this.activeModal;
      },
      set(val) {
        if(!val) this.$emit('closeModal')
      }
    }
  },
  methods:{
    handleClick(){
      this.modalActive = false
    },
    fetchLidershipExperience(){
      getLidershipExperienceById({ id: this.id}).then(response => {
        this.lidership_experience = response.data.data
      })
    },
    handleSubmit() {
      if (this.lidership_experience.name_uz
          && this.lidership_experience.name_ru
          && this.lidership_experience.name_en
          && this.lidership_experience.name_kz) {
        if (this.id) {
          // eslint-disable-next-line no-unused-vars
          editLidershipExperience(this.lidership_experience).then(res => {
            this.$emit('closeModal')
          })
        } else {
          // eslint-disable-next-line no-unused-vars
          addLidershipExperience(this.lidership_experience).then(res => {
            this.$emit('closeModal')
          })
        }
      }
    },
  },
  watch: {
    id:{
      immediate: true,
      handler(val) {
        if(val) {
          this.fetchLidershipExperience()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>




